import PatientProfileNew from '../../components/patient/PatientProfileNew';

export default function PatientProfilePage() {
  return <PatientProfileNew />;
}
